import { render, staticRenderFns } from "./educationCompany.vue?vue&type=template&id=9da1e968"
import script from "./educationCompany.vue?vue&type=script&lang=js"
export * from "./educationCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports